import React from 'react';
import { Button, Badge, Spinner } from 'react-bootstrap';
import { getStatusBadgeVariant } from '../../../util/agendaHelpers';
import AtividadeActionsDropdown from './AtividadeActionsDropdown';
import { abreviarNome } from '../../../util/utils';

const EMPTY_ATIVIDADE = {};
const EMPTY_ACTIONS = {};

const AtividadeRow = React.memo(
  ({ atividade = EMPTY_ATIVIDADE, actions = EMPTY_ACTIONS }) => {
    const { handleLaudar, loadingAtividadeId } = actions;

    const canHandleLaudar = typeof handleLaudar === 'function';
    const isLoadingAtividade = loadingAtividadeId === atividade.CODLAUDO;

    return (
      <tr
        className="m-0 p-0 align-middle"
        style={{
          fontSize: '0.75rem',
          lineHeight: 1.1,
        }}
      >
        {/* Procedimento */}
        <td className="m-0 p-0">
          <Button
            onClick={() => {
              if (canHandleLaudar) handleLaudar(atividade);
            }}
            variant="link"
            size="sm"
            disabled={!canHandleLaudar || isLoadingAtividade}
            className="p-0 text-decoration-none"
            style={{
              fontSize: '0.75rem',
              lineHeight: 1.1,
            }}
          >
            {atividade.DESCPROCEDI?.split(' ')[0] || '-'}
          </Button>
        </td>

        {/* Convênio */}
        <td className="m-0 p-0">
          {atividade.SIGLACONV?.length > 10
            ? `${atividade.SIGLACONV.substring(0, 14)}...`
            : atividade.SIGLACONV || '-'}
        </td>

        {/* Data */}
        <td className="m-0 p-0">
          {atividade.dataFormatada || '-'}
        </td>

        {/* Código do laudo */}
        <td className="m-0 p-0">
          {atividade.CODLAUDO || '-'}
        </td>

        {/* Guia */}
        <td className="m-0 p-0">
          {atividade.GUIA || '-'}
        </td>

        {/* Valor */}
        <td className="m-0 p-0">
          {atividade.VLRLAUDO ?? '-'}
        </td>

        {/* Status da guia */}
        <td className="m-0 p-0 text-center">
          <Badge
            pill
            variant={getStatusBadgeVariant(
              atividade.GUIA1,
              'GUIA1'
            )}
            style={{
              fontSize: '0.65rem',
              lineHeight: 1,
              padding: '3px 5px',
            }}
          >
            {atividade.GUIA1 || '-'}
          </Badge>
        </td>

        {/* Código do convênio */}
        <td className="m-0 p-0">
          {atividade.CODCONV || '-'}
        </td>

        {/* Médico */}
        <td className="m-0 p-0">
          {atividade.CODMEDICO || '-'}
        </td>

        {/* Médico que encaminhou */}
        <td className="m-0 p-0">
          {atividade.CODENCAMINHOU || '-'}
        </td>

        {/* Médico que realizou */}
        <td className="m-0 p-0">
          {atividade.CODREALIZOU || '-'}
        </td>

        {/* Código da fatura */}
        <td className="m-0 p-0">
          {atividade.CODFATURA || '-'}
        </td>

        {/* Funcionário */}
        <td className="m-0 p-0">
          {atividade.NOMEFUNC ? (
            <span
              title={atividade.NOMEFUNC}
              style={{
                fontSize: '0.68rem',
                fontWeight: 600,
                color: '#495057',
                backgroundColor: '#a3f3c1ff',
                borderRadius: '3px',
                padding: '1px 4px',
                whiteSpace: 'nowrap',
              }}
            >
              {abreviarNome(atividade.NOMEFUNC)}
            </span>
          ) : (
            '-'
          )}
        </td>

        {/* Status do PDF */}
        <td className="m-0 p-0 text-center">
          <Badge
            pill
            variant={getStatusBadgeVariant(
              atividade.PDF_STATUS,
              'PDF_STATUS'
            )}
            style={{
              fontSize: '0.65rem',
              lineHeight: 1,
              padding: '3px 5px',
            }}
          >
            {atividade.PDF_STATUS || '-'}
          </Badge>
        </td>

        {/* Ações */}
        <td className="m-0 p-0 text-center">
          {isLoadingAtividade ? (
            <Spinner
              animation="border"
              size="sm"
              role="status"
              aria-label="Carregando laudo"
              style={{
                width: '0.8rem',
                height: '0.8rem',
              }}
            />
          ) : (
            <AtividadeActionsDropdown
              atividade={atividade}
              actions={actions}
            />
          )}
        </td>
      </tr>
    );
  }
);

export default AtividadeRow;